import { useRef, useState } from "react";
import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js";
import api from "@/lib/api";

const names = new Intl.DisplayNames(["en"], { type: "region" });
export const COUNTRIES = getCountries()
  .map((code) => ({ code, name: names.of(code) || code, dial: getCountryCallingCode(code) }))
  .sort((a, b) => (a.code === "IN" ? -1 : b.code === "IN" ? 1 : a.name.localeCompare(b.name)));

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
const EMPTY = { name: "", email: "", phone: "", countryCode: "IN", company: "", subject: "", message: "" };

export function validateLead(f) {
  const e = {};
  if (f.name.trim().length < 2) e.name = "Please enter your full name";
  if (!EMAIL_RE.test(f.email.trim())) e.email = "Please enter a valid email address";
  const p = parsePhoneNumberFromString(f.phone, f.countryCode);
  if (!f.phone.trim()) e.phone = "Please enter your phone number";
  else if (!p || !p.isValid() || p.country !== f.countryCode) e.phone = `Enter a valid ${names.of(f.countryCode)} phone number`;
  if (f.message.trim().length < 5) e.message = "Please describe your requirement (min 5 characters)";
  return e;
}

export function useLeadForm(leadType, productSlug) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);

  const update = (k) => (ev) => {
    setForm((f) => ({ ...f, [k]: ev.target.value }));
    setErrors((er) => ({ ...er, [k]: undefined }));
  };

  const submit = async () => {
    if (lock.current) return { ok: false };
    const errs = validateLead(form);
    setErrors(errs);
    if (Object.keys(errs).length) return { ok: false };
    lock.current = true;
    setBusy(true);
    try {
      const phone = parsePhoneNumberFromString(form.phone, form.countryCode).number;
      const { data } = await api.post("/leads", {
        name: form.name.trim(), email: form.email.trim(), phone, company: form.company.trim(),
        country: names.of(form.countryCode), country_code: form.countryCode, subject: form.subject.trim(),
        message: form.message.trim(), product_slug: productSlug || null, lead_type: leadType,
      });
      if (!data?.success || !data?.lead_id) throw new Error("not saved");
      setForm(EMPTY);
      return { ok: true, id: data.lead_id };
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail) ? detail[0]?.msg?.replace(/^Value error, /, "") : null;
      return { ok: false, error: msg || "We could not submit your enquiry. Please try again or call +91 98100 12256." };
    } finally {
      lock.current = false;
      setBusy(false);
    }
  };

  return { form, errors, busy, update, submit };
}
